<template>
    <div>
        <h4>Лог системи</h4>
        <Button
            label="Очистить лог"
            icon="pi pi-trash"
            class="but btn-danger mb-2"
            @click="clearLog()"
        />

        <div class="log_container">
            <pre v-if="log === ''">Лог пустий..</pre>
            <pre v-else v-html="log"></pre>
        </div>
    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import FileUpload from 'primevue/fileupload';
import Toast from 'primevue/toast';
import ProgressBar from 'primevue/progressbar';
import moment from "moment";
import Input from '../Jetstream/Input.vue';
import axios from "axios";
import Button from "primevue/button";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import swal from 'sweetalert2';

export default {
    layout: AppLayout,
    props: {
        log: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            moment: moment,
        }
    },
    components: {
        ProgressBar,
        "p-fileupload": FileUpload,
        "p-toast": Toast,
        Input,
        Button,
        DataTable,
        Column,
        swal,
    },
    methods: {
        clearLog() {
            axios.get(this.route('log.delete'))
                .then((result) => {
                    this.$toast.add({severity: 'info', summary: 'Success', detail: 'Log cleared!', life: 3000});
                    location.reload();
                }).catch((error) => {
                    this.$toast.add({severity: 'error', summary: 'Error', detail: 'Clear Error', life: 3000});
                    window.scroll(0, 0);
                })
        }
    }
};
</script>

<style scoped>
.log_container {
    width: 100%;
    height: 600px;
    overflow: auto;
}
</style>
